import { Store } from '@reactive-redux/store';
import { Injectable } from '@rxdi/core';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppStateInterface } from './app.interface';
import { initialState } from './initial.state';
import { reducerFn } from './reducers';
import { dbUpdates, history } from './transducers';

@Injectable()
export class AppState extends Store<AppStateInterface> {
  static readonly initialState: AppStateInterface = initialState;
  static readonly reducer = reducerFn;
  static readonly middleware = [history, dbUpdates];
  static readonly destroy$ = new Subject();

  constructor() {
    super({
      initialState$: of(AppState.initialState),
      reducer$: of(AppState.reducer),
      middleware$: of(AppState.middleware),
      destroy$: AppState.destroy$.asObservable(),
    });
  }

  destroy() {
    AppState.destroy$.next(true);
  }

  select<K>(mapFn: (state: AppStateInterface) => K): Observable<K> {
    return this.state$.pipe(map(mapFn));
  }
}
